// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC3ZsNjjfU9VHFbsZCYQ5emOVqRVWHrNtg",
  authDomain: "news-capital-admin.firebaseapp.com",
  projectId: "news-capital-admin",
  storageBucket: "news-capital-admin.firebasestorage.app",
  messagingSenderId: "423329583805",
  appId: "1:423329583805:web:3676d1c8d6d3b91c16ddd4",
  measurementId: "G-E0R918BVM8",
};
const firebaseApp = initializeApp(firebaseConfig);
export const messaging = getMessaging(firebaseApp);

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey:
        "BMYUWhhthSWQUavgRMq0oL8nsdTr1bzXCzdmUIRbX6GwnEt-0KG-M66tJpPR_pC5iiBDNX47Xg52Th8B56pJWr0",
    });
    return token;
  }
  if (permission === "denied") {
    return "";
  }
};
